module.exports = __webpack_public_path__ + "img/UHF-DVS-25.45992eea.webp";